import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  private Content_Type = 'application/json';
  url_auth = environment.api_update_authentication;

  constructor(private httpClient: HttpClient) { }


  /**
* update
*/
  public update(body) {
    let headers = new HttpHeaders()
    .set("Content-Type", this.Content_Type);    
    return this.httpClient.post(
      this.url_auth + "update",
      body
    );
  }
}
